import React, { useState } from 'react';
import { useEffect } from 'react';
import Select from 'react-select';
import useAxios from 'hooks/useAxios';

const PharmacyList = ({ selectedPharmacy, onSelect }) => {
    const API = useAxios();
    const [state, setState] = useState({
        pharmacyList: [],
        loading: false,
        pharmacy: '',
    });

    const { loading, pharmacyList, pharmacy } = state;

    useEffect(() => {
        if (pharmacyList.length && !selectedPharmacy) {
            setState((pre) => ({ ...pre, pharmacyList: [] }));
        }
    }, [selectedPharmacy]);

    const findPharmacy = async (value) => {
        // if (!tenantID)
        //     return setState((pre) => ({ ...pre, pharmacy: value, pharmacyList: [] }));
        setState((pre) => ({ ...pre, pharmacy: value }));
        if (!value) {
            return setState((pre) => ({ ...pre, pharmacyList: [] }));
        }

        if (value && value.length < 3) {
            return setState((pre) => ({ ...pre, pharmacyList: [] }));
        }

        setState((pre) => ({ ...pre, loading: true }));
        try {
            const { data } = await API.get(
                `Config/pharmacy/pharmacy/${value}`,
                { hideLoader: true }
            );
            setState((pre) => ({
                ...pre,
                pharmacyList: data,
                loading: false,
            }));
        } catch (error) {
            setState((pre) => ({ ...pre, loading: false }));
        }
    };

    const onSelectPharmacy = (pharmacy) => {
        onSelect(pharmacy);
    };

    return (
        <Select
            className='form-field-large inner-shadow-field' //npi-name
            classNamePrefix='select'
            IndicatorSeparator
            isClearable={true}
            isSearchable={true}
            isLoading={loading}
            placeholder='Enter Pharmacy'
            name='color'
            options={pharmacyList}
            value={selectedPharmacy}
            inputValue={pharmacy}
            onInputChange={findPharmacy}
            onChange={onSelectPharmacy}
            getOptionLabel={(option) => option.displayName}
            getOptionValue={(option) => option.pharmacyId}
            // isDisabled={!tenantID}
            components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
            }}
            styles={{
                menu: (provided) => ({
                    ...provided,
                    zIndex: 99,
                }),
            }}
        />
    );
}

export default PharmacyList;